// import React from "react";
// import MuiButton from "@mui/material/Button";
// import Icon from "../icon/Icon";
// import Translation from "../../localization/Translation";
// import styles from "./Print.module.scss";

// const Print = ({ reactToPrintFn, className }) => {
//   return (
//     <div className={styles["print"]}>
//       {/* <button onClick={reactToPrintFn}>Print</button> */}
//       <MuiButton className={className} onClick={reactToPrintFn}>
//         <Icon symbol="print" />
//         <Translation>Print</Translation>
//       </MuiButton>
//     </div>
//   );
// };
// Print.defaultProps = {
//   className: styles["print__btn"]
// };

// export default Print;


import React from "react";
import MuiButton from "@mui/material/Button";
import Icon from "../icon/Icon";
import Translation from "../../localization/Translation";
import ReactToPrint from "react-to-print";
import styles from "./Print.module.scss";

const Print = ({ reference, className }) => (
  <div className={styles["print"]}>
    <ReactToPrint
      trigger={() => (
        <MuiButton className={className}>
          <Icon symbol="print" />
          <Translation>Print</Translation>
        </MuiButton>
      )}
      content={() => {
        if (!reference) return null;
        return reference.current ? reference.current : reference;
      }}
    />
  </div>
);

Print.defaultProps = {
  className: styles["print__btn"]
};

export default Print;
